<template>
  <el-dialog
    title="出险锁定"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    @closed="reset"
  >
    <el-descriptions v-if="employee" :column="1" border size="small">
      <el-descriptions-item label="员工姓名">
        {{ employee.name || "-" }}
      </el-descriptions-item>
      <el-descriptions-item label="身份证号">
        {{ employee.idcard || "-" }}
      </el-descriptions-item>
      <el-descriptions-item label="保单号">
        {{ employee.policy_no || "-" }}
      </el-descriptions-item>
    </el-descriptions>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="90px"
      class="lock-form"
    >
      <el-form-item label="锁定说明" prop="note">
        <el-input
          v-model.trim="form.note"
          type="textarea"
          :rows="5"
          maxlength="300"
          show-word-limit
          placeholder="请输入出险锁定说明"
        />
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="submitting"
        @click="submit"
      >
        确定锁定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { lockEmployerEmployee } from "@/api/employer-insurance";

export default {
  name: "EmployeeLockDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    employee: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      submitting: false,
      form: {
        note: ""
      },
      rules: {
        note: [
          { required: true, message: "请输入锁定说明", trigger: "blur" },
          { max: 300, message: "锁定说明不能超过 300 个字符", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
  },
  methods: {
    reset() {
      this.submitting = false;
      this.form.note = "";
      if (this.$refs.form) this.$refs.form.clearValidate();
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid || !this.employee) return;
        this.submitting = true;
        try {
          const res = await lockEmployerEmployee({
            id: Number(this.employee.id),
            note: this.form.note.trim()
          });
          if (!res) return;
          this.$message.success("锁定成功");
          this.dialogVisible = false;
          this.$emit("success");
        } finally {
          this.submitting = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.lock-form {
  margin-top: 20px;
}
</style>
